// powerlete-reveal.js
// Shared scroll-reveal for the About Us sections. Progressive enhancement:
// elements are fully visible without JS and for anyone who prefers reduced
// motion. Only when JS runs (and motion is allowed) do we hide-then-reveal
// them as they enter the viewport. One IntersectionObserver for the page.

const SELECTOR = '[data-pw-reveal]';
const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

function revealNow(el) {
  el.classList.add('pw-reveal--in');
}

function init(root) {
  const scope = root && root.querySelectorAll ? root : document;
  const items = scope.querySelectorAll(SELECTOR);
  if (!items.length) return;

  // Reduced motion or no observer support: show everything immediately.
  if (reduceMotion.matches || !('IntersectionObserver' in window)) {
    items.forEach(revealNow);
    return;
  }

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        revealNow(entry.target);
        obs.unobserve(entry.target);
      });
    },
    { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
  );

  items.forEach((el) => {
    // Opt the element into the hidden start-state only now that JS will
    // guarantee a reveal, so a JS failure never leaves content invisible.
    el.classList.add('pw-reveal--ready');
    observer.observe(el);
  });
}

if (document.readyState !== 'loading') {
  init(document);
} else {
  document.addEventListener('DOMContentLoaded', () => init(document));
}

// Theme editor: re-scan a section when it is added or reloaded.
document.addEventListener('shopify:section:load', (event) => init(event.target));
